import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Tag = loadable(() => pMinDelay(import('./Tag'), 300), {
  fallback: <Loading />
});

const AsyncTag = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Tag { ...props } />
    </ApplicationLayout>
  );
};

AsyncTag.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncTag;
